/* eslint-disable no-param-reassign */
/* @flow */

/**
 * export @reducer decorator
 * the reducer decorator marks a method as a state reducer handler for
 * when a action is dispatched
 */
export function reducer(_: Object, key: String, descriptor: Object): Object {
  const fn = descriptor.value;

  descriptor.value = () => {
    throw new Error('A reducer method should not be called directly, use dispatcher shortcut');
  };

  descriptor.value._reducer = {
    key: key.replace('_', ''),
    fn,
  };

  return descriptor;
}
